<!--
/**
* @name: List.vue
* @description: 配额管理-列表页面
* @author: 杨波
* @create: 2022/06/09 14:06:58
* @update: 2022/06/09 14:06:58
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-select placeholder="请选择状态" clearable v-model="para.status">
          <k-option v-for="item in statusList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-input placeholder="请输入规则名称" clearable v-model="para.title"></k-input>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
      <y-query-item slot="right">
        <k-button type="primary" @click="handleLinkToDetail({}, 0)">添加配额规则</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="quotaList" :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>
<script>
import { NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_PAGE, NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_VERIFY, NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_CANCEL } from "@/assets/modules/apiList";
const initPara = () => ({
  status: "", //规则状态
  title: "", //规则名称
  goodsId: "", //商品ID
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      isLoading: false,
      quotaList: [],
      goodsId: "",
      para: initPara(),
      statusList: [
        { code: 1, name: "待审核" },
        { code: 2, name: "待开始" },
        { code: 3, name: "生效中" },
        { code: 4, name: "已作废" },
        { code: 5, name: "已结束" },
      ],
      total: 0,
    };
  },
  methods: {
    /** 提取table公共样式 */
    tableStyle(w) {
      return {
        width: w ? w : 80,
        "text-align": "center",
        "white-space": "normal",
        "word-break": "break-all",
      };
    },

    /** 初始化表格 */
    initColumns() {
      let tableItem = [
        { name: "规则编码", style: this.tableStyle(80), customRender: (row) => <div>{row.id ? row.id : "——"}</div> },
        { name: "规则名称", style: this.tableStyle(120), customRender: (row) => <div>{row.title ? row.title : "——"}</div> },
        { name: "配额批次", style: this.tableStyle(120), customRender: (row) => <div>{row.batchNo ? row.batchNo : "——"}</div> },
        { name: "配额数量", style: this.tableStyle(80), customRender: (row) => <div>{row.quotaCount}</div> },
        { name: "规则开始时间", style: this.tableStyle(120), customRender: (row) => <div>{row.startTime ? row.startTime : "——"}</div> },
        { name: "规则结束时间", style: this.tableStyle(120), customRender: (row) => <div>{row.endTime ? row.endTime : "——"}</div> },
        {
          name: "配额状态",
          style: this.tableStyle(80),
          customRender: (row) => <div>{row.status == 1 ? "待审核" : row.status == 2 ? "待开始" : row.status == 3 ? "生效中" : row.status == 4 ? "已作废" : row.status == 5 ? "已结束" : "——"}</div>,
        },
        { name: "创建时间", style: this.tableStyle(120), customRender: (row) => <div>{row.createTime ? row.createTime : "——"}</div> },
        {
          name: "操作",
          style: this.tableStyle(120),
          customRender: (row) => (
            <div>
              {row.status == 1 && (
                <a href="javascript:;" onclick={() => this.handleLinkToAudit(row)}>
                  审核&#12288;
                </a>
              )}
              <a href="javascript:;" onclick={() => this.handleLinkToDetail(row, 1)}>
                查看&#12288;
              </a>
              {(row.status == 2 || row.status == 3) && (
                <a href="javascript:;" onclick={() => this.handleLinkToCancel(row)}>
                  作废&#12288;
                </a>
              )}
              {(row.status == 1 || row.status == 2 || row.status == 3) && (
                <a href="javascript:;" onclick={() => this.handleLinkToDetail(row, 2)}>
                  编辑
                </a>
              )}
            </div>
          ),
        },
      ];
      return tableItem;
    },

    /** 配额规则审核操作 */
    handleLinkToAudit(row) {
      this.$dialog({
        title: "提示",
        content: "是否确认审核当前配额规则？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_VERIFY,
            para: { id: row.id },
          })
            .then(() => {
              this.isLoading = false;
              this.getQuotaList();
              this.$root.tip("操作成功", "success");
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },

    /** 配额规则作废操作 */
    handleLinkToCancel(row) {
      this.$dialog({
        title: "提示",
        content: "是否确认作废当前配额规则？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_CANCEL,
            para: { id: row.id },
          })
            .then(() => {
              this.isLoading = false;
              this.getQuotaList();
              this.$root.tip("操作成功", "success");
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },

    /** 新增/查看配额规则操作 */
    handleLinkToDetail(row, showType) {
      this.$controller.open({
        name: "quotaAdd",
        query: {
          refresh: new Date() - 0,
          id: row.id ? row.id : "",
          goodsId: this.goodsId,
          showType: showType,
        },
        title: `配额规则-${["添加", "详情", "编辑"][showType]}`,
      });
    },

    /** 条件查询配额规则列表数据 */
    onSearch() {
      this.para.pageCurrent = 1;
      this.getQuotaList();
    },

    /** 重置配额规则列表查询条件 */
    onReset() {
      this.para = initPara();
      this.para.goodsId = this.goodsId;
      this.getQuotaList();
    },

    /** 编辑配额规则信息 */
    onEdit(row) {
      const { goodsBrandCode } = row;
      this.$controller.open({
        name: "brandAdd",
        query: {
          refresh: new Date() - 0,
          goodsBrandCode,
          edit: 1,
        },
        title: "编辑品牌",
      });
    },

    /** 分页查询配额规则列表数据 */
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getQuotaList();
    },

    /** 获取配额规则列表数据 */
    getQuotaList() {
      this.isLoading = true;
      this.para.goodsId = this.goodsId;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_QUOTA_PAGE,
        para: this.para,
      })
        .then((res) => {
          this.quotaList = res.pageList || [];
          this.total = res.total;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    const { id } = this.$route.query;
    this.goodsId = id;
    this.getQuotaList();
  },
  beforeRouteUpdate(to, from, next) {
    const { id } = to.query;
    this.goodsId = id;
    this.getQuotaList();
    next();
  },
};
</script>
